export const normalizeAccountType = (accountType) =>
  String(accountType || "").trim().toLowerCase();

export const isAdminAccount = (userdetails) =>
  normalizeAccountType(
    userdetails?.account_type ||
      userdetails?.accountType ||
      userdetails?.role ||
      userdetails?.user_role
  ) === "admin";
